<template>
<div v-if="loading" class="container">
    <img class="hidden-md hidden-sm hidden-xs" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/Speaker_Detail_Placeholder_Desktop_v1.svg" alt="">
    <img class="hidden-lg hidden-sm hidden-xs" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/Speaker_Detail_Placeholder_Tablet_v1.svg" alt="">
    <img class="hidden-md hidden-lg" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/Speaker_Detail_Placeholder_Mobile_v1.svg" alt="">
</div>

<div v-if="!loading && dataToDisplay && dataToDisplay.length" class='vue-talk-detail'>
    <div class="hidden-md hidden-xs hidden-sm" v-if="disturberHtml" v-html="disturberHtml">
    </div>
    <div class="gdlr-page-title-wrapper gdlr-parallax-wrapper gdlr-title-normal" v-for="sessionDetail in dataToDisplay" :key="sessionDetail.id">
        <div class="gdlr-page-title-overlay vueHeader"></div>
        <div class="gdlr-page-title-container vueHeader" :class="container">
            <h1 v-if="sessionDetail && sessionDetail.pageCaption" class="gdlr-page-caption" v-html="sessionDetail.pageCaption"></h1>
            <h1 v-if="sessionDetail && sessionDetail.title" class="gdlr-page-title sands-gdlr-page-title">{{sessionDetail.title}}</h1>
            <div v-if="sessionDetail && sessionDetail.sessionTypeIs && sessionDetail.sessionTypeIs.name && sessionDetail.sessionTypeIs.slug" class="session-type">{{sessionDetail.sessionTypeIs.name}}</div>
            <span v-if="sessionDetail.tracks">
                <div class="tagcontainer">
                    <span v-for="track in sessionDetail.tracks" :key="track._id">
                        <a class="tagcontaineritem ijsstyle classicstyle" v-if="track && track.slug" :href="'/'+track.slug">{{track.name}}</a>
                    </span>
                </div>
            </span>
            <span v-if="!sessionDetail.tracks && sessionDetail.wpTracks">
                <div class="tagcontainer">
                    <span v-for="track in sessionDetail.wpTracks" :key="track._id">
                        <a class="tagcontaineritem ijsstyle classicstyle" v-if="track && track[0] && track[0].name" :href="track[0].slug">{{track[0].name}}</a>
                    </span>
                </div>
            </span>
        </div>
    </div>
    <div class="with-sidebar-wrapper">
        <div class="with-sidebar-container sands-container  gdlr-class-no-sidebar">
            <div class="with-sidebar-left twelve columns">
                <div class="with-sidebar-content twelve columns">
                    <div class="gdlr-item gdlr-item-start-content">
                        <div class="hidden-xs hidden-sm">
                            <div v-if="showWPData && settingsPerm && settingsPerm.sands_mlc_show_program_infos">
                                <div class="" v-html="settingsPerm.sands_mlc_show_program_infos">
                                </div>
                            </div>
                            <div v-if='cookie && (typeof cookie !== " undefined") && (cookie !="" ) && (cookie !="all" ) && !showWPData && identifierFound'>
                                <template v-for="aLocation in settingsPerm.allLocations" :key="aLocation._id">
                                    <div v-if="aLocation && aLocation.programbuttonLink && aLocation.identifier && currentMlcLocation && currentMlcLocation.identifier && aLocation.identifier == currentMlcLocation.identifier && conferenceIdSameAsCurrentLocationInstanceId">
                                        <div class="to-the-current-program-page-block global-bg-color__session mlc-location-dependent-block-invisible global-border-radius" :class="aLocation.identifier">
                                            <p class="">
                                                <span class="language-dependent-block-invisible go-to-program-page">Take me to the program of </span>
                                                <span class="language-dependent-block-invisible-de go-to-program-page">Hier geht es zum Programm von </span>
                                                <a :style="{'color':aLocation.location_color}" class="language-dependent-block-invisible go-to-program-page " :class="aLocation.identifier" :href="aLocation.programbuttonLink"> &nbsp;{{aLocation.city}}</a>
                                                <a :style="{'color':aLocation.location_color}" class="language-dependent-block-invisible-de go-to-program-page" :class="aLocation.identifier" :href="aLocation.programbuttonLink_DE"> &nbsp;{{aLocation.city_de}}</a>.
                                            </p>
                                        </div>
                                    </div>
                                    <div v-else-if="aLocation && aLocation.programbuttonLink && aLocation.identifier && !isArchiveSession">
                                        <div class="to-the-current-program-page-block global-bg-color__session mlc-location-dependent-block-invisible global-border-radius" :class="aLocation.identifier">
                                            <p class="">
                                                <span class="language-dependent-block-invisible go-to-program-page">This Session belongs to the&nbsp;</span>
                                                <span class="language-dependent-block-invisible-de go-to-program-page">Diese Session geh&ouml;rt zum Programm von&nbsp; </span>
                                                <a v-for="(aRelatedLocation, index) in locationsRelatedToThisSession" :key="index" :href="aRelatedLocation.programbuttonLink" :style="{'color':aRelatedLocation.location_color}" class="language-dependent-block-invisible go-to-program-page ">{{aRelatedLocation.city}} <span v-if="index < locationsRelatedToThisSession.length -  2">,&nbsp;</span>
                                                    <span v-if="index == locationsRelatedToThisSession.length -  2">{{ $t('or') }}&nbsp;</span>
                                                </a>
                                                <a v-for="(aRelatedLocation, index) in locationsRelatedToThisSession" :key="index" :style="{'color':aRelatedLocation.location_color}" class="language-dependent-block-invisible-de go-to-program-page hhh" :class="aRelatedLocation.identifier" :href="aRelatedLocation.programbuttonLink_DE"> &nbsp;{{aRelatedLocation.city_de}}
                                                    <span v-if="index < locationsRelatedToThisSession.length -  2">,&nbsp;</span>
                                                    <span v-if="index == locationsRelatedToThisSession.length -  2">{{ $t('or') }}&nbsp;</span>
                                                </a>
                                                <span class="language-dependent-block-invisible go-to-program-page">&nbsp;program. Take me to the program of </span>
                                                <span class="language-dependent-block-invisible-de go-to-program-page">. Hier geht es zum Programm von </span>
                                                <a :style="{'color':aLocation.location_color}" class="language-dependent-block-invisible go-to-program-page " :class="aLocation.identifier" :href="aLocation.programbuttonLink"> &nbsp;{{aLocation.city}}</a>
                                                <a :style="{'color':aLocation.location_color}" class="language-dependent-block-invisible-de go-to-program-page" :class="aLocation.identifier" :href="aLocation.programbuttonLink_DE"> &nbsp;{{aLocation.city_de}}</a>.
                                            </p>
                                        </div>
                                    </div>
                                    <div v-else-if="isArchiveSession && locationAliasesOfThePost && locationAliasesOfThePost.length">
                                        <div class="to-the-current-program-page-block global-bg-color__session mlc-location-dependent-block-invisible global-border-radius" :class="aLocation.identifier">
                                            <p class="">
                                                <span class="language-dependent-block-invisible go-to-program-page">This Session originates from the archive of </span>
                                                <span class="language-dependent-block-invisible-de go-to-program-page">Diese Session stammt aus dem Archiv von </span>
                                                <template v-for="(aLocationAlias, index) in locationAliasesOfThePost" :key="index">
                                                    <span class="language-dependent-block-invisible go-to-program-page " :class="aLocation.identifier"> &nbsp;{{aLocationAlias.edition_label_en}}</span>
                                                    <span class="language-dependent-block-invisible-de go-to-program-page" :class="aLocation.identifier"> &nbsp;{{aLocationAlias.edition_label_de}}</span>
                                                    <span v-if="locationAliasesOfThePost.length > 1">
                                                        <span v-if="index === locationAliasesOfThePost.length - 1">
                                                            <span class="language-dependent-block-invisible go-to-program-page">&nbsp;and&nbsp;</span><span class="language-dependent-block-invisible-de go-to-program-page">&nbsp;und&nbsp;</span>
                                                        </span>
                                                        <span v-else-if="index < locationAliasesOfThePost.length">,</span>
                                                    </span>
                                                </template>
                                                <span class="language-dependent-block-invisible go-to-program-page">. Take me to the program of </span>
                                                <span class="language-dependent-block-invisible-de go-to-program-page">. Hier geht es zum aktuellen Programm von </span>
                                                <a :style="{'color':aLocation.location_color}" class="language-dependent-block-invisible go-to-program-page" :class="aLocation.identifier" :href="aLocation.programbuttonLink"> &nbsp;{{aLocation.city}}</a>
                                                <a :style="{'color':aLocation.location_color}" class="language-dependent-block-invisible-de go-to-program-page" :class="aLocation.identifier" :href="aLocation.programbuttonLink_DE"> &nbsp;{{aLocation.city_de}}</a>.</p>
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <div v-if="(!cookie || cookie == 'all' || cookie == undefined) && (identifierFound)">
                                <div class="mlc-location-independent-block-invisible global-bg-color__session to-the-current-program-page-block global-border-radius" v-if="settingsPerm && settingsPerm.allLocations && !showWPData">
                                    <div v-if="!isArchiveSession">
                                        <span class="language-dependent-block-invisible go-to-program-page">This session belongs to the</span>
                                        <span class="language-dependent-block-invisible-de go-to-program-page">Dieser session geh&ouml;rt zum Programm von</span>
                                        <template v-for="(aLocation, index) in editionsOfThisSession" :key="index">
                                            <span class="language-dependent-block-invisible go-to-program-page "> &nbsp;{{aLocation.city}}</span>
                                            <span class="language-dependent-block-invisible-de go-to-program-page"> &nbsp;{{aLocation.city_de}}</span>
                                            <span v-if="index != editionsOfThisSession.length - 1">
                                                <span class="language-dependent-block-invisible go-to-program-page">&nbsp;and&nbsp;</span><span class="language-dependent-block-invisible-de go-to-program-page">&nbsp;und&nbsp;</span>
                                            </span>
                                        </template>
                                        <span class="language-dependent-block-invisible go-to-program-page">&nbsp;program. Take me to the program of </span>
                                        <span class="language-dependent-block-invisible-de go-to-program-page">. Hier geht es zum Programm von </span>
                                        <template v-for="(aEdition,index) in settingsPerm.allLocations" :key="index">
                                            <span v-if="aEdition && aEdition.location_is_active && aEdition.location_is_active == 1">
                                                <a :style="{'color':aEdition.location_color}" class="language-dependent-block-invisible go-to-program-page " :class="aEdition.identifier" :href="aEdition.programbuttonLink"> &nbsp;{{aEdition.city}}</a>
                                                <a :style="{'color':aEdition.location_color}" class="language-dependent-block-invisible-de go-to-program-page" :class="aEdition.identifier" :href="aEdition.programbuttonLink_DE"> &nbsp;{{aEdition.city_de}}</a>
                                                <span v-if="index != settingsPerm.allLocations.length - 1">
                                                    <span class="language-dependent-block-invisible go-to-program-page">&nbsp;or&nbsp;</span><span class="language-dependent-block-invisible-de go-to-program-page">&nbsp;oder&nbsp;</span>
                                                </span>
                                            </span>

                                        </template>
                                    </div>
                                    <div v-else-if="isArchiveSession && locationAliasesOfThePost && locationAliasesOfThePost.length">
                                        <span class="language-dependent-block-invisible go-to-program-page">This Session originates from the archive of </span>
                                        <span class="language-dependent-block-invisible-de go-to-program-page">Diese Session stammt aus dem Archiv von </span>
                                        <template v-for="(aLocationAlias, index) in locationAliasesOfThePost" :key="index">
                                            <span class="language-dependent-block-invisible go-to-program-page "> &nbsp;{{aLocationAlias.edition_label_en}}</span>
                                            <span class="language-dependent-block-invisible-de go-to-program-page"> &nbsp;{{aLocationAlias.edition_label_de}}</span>
                                            <span v-if="locationAliasesOfThePost.length > 1">
                                                <span v-if="index === locationAliasesOfThePost.length - 1">
                                                    <span class="language-dependent-block-invisible go-to-program-page">&nbsp;and&nbsp;</span><span class="language-dependent-block-invisible-de go-to-program-page">&nbsp;und&nbsp;</span>
                                                </span>
                                                <span v-else-if="index < locationAliasesOfThePost.length">,</span>
                                            </span>
                                        </template>
                                        <span class="language-dependent-block-invisible go-to-program-page">. Take me to the program of </span>
                                        <span class="language-dependent-block-invisible-de go-to-program-page">. Hier geht es zum aktuellen Programm von </span>
                                        <template v-for="(aEdition,index) in settingsPerm.allLocations" :key="index">
                                            <span v-if="aEdition && aEdition.location_is_active && aEdition.location_is_active == 1">
                                                <a :style="{'color':aEdition.location_color}" class="language-dependent-block-invisible go-to-program-page " :class="aEdition.identifier" :href="aEdition.programbuttonLink"> &nbsp;{{aEdition.city}}</a>
                                                <a :style="{'color':aEdition.location_color}" class="language-dependent-block-invisible-de go-to-program-page" :class="aEdition.identifier" :href="aEdition.programbuttonLink_DE"> &nbsp;{{aEdition.city_de}}</a>
                                                <span v-if="index != settingsPerm.allLocations.length - 1">
                                                    <span class="language-dependent-block-invisible go-to-program-page">&nbsp;or&nbsp;</span><span class="language-dependent-block-invisible-de go-to-program-page">&nbsp;oder&nbsp;</span>
                                                </span>
                                            </span>

                                        </template>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="sands-flex-outer-container">
                            <template v-for="sessionDetail in dataToDisplay" :key="sessionDetail.id">
                                <div class="sands-flex-container">
                                    <div class="sands-inner-flex-container">
                                        <div class="speaker-infos flexbox-1">
                                            <div v-if="sessionDetail.experts && sessionDetail.experts.length" class='speaker-boxes global-bg-color__session ws-lp global-border-radius'>
                                                <h2>Speaker</h2>
                                                <div v-for="expert in sessionDetail.experts" :key="expert.id">
                                                    <div class="gdlr-speaker-thumbnail">
                                                        <div class="gdlr-speaker-thumbnail-inner" v-if="expert && expert.surname && expert.forename && expert.slug">
                                                            <a :href="'/speaker/'+expert.slug">
                                                                <div v-if="expert && expert.avatarSquareSmall && expert.avatarSquareSmall.xxx" class="sands-image-colored-overlay-hover">
                                                                    <img :src="expert.avatarSquareSmall.xxx" :alt="expert.forename + ' ' + expert.surname" width="500" height="350"></div>
                                                                <div class="span-speaker-container">
                                                                    <p class="span-speaker-left"><span>{{expert.forename}}</span> <span> {{expert.surname}}</span></p>
                                                                    <p class="span-speaker-right">{{ $t('more-info') }}</p>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div class="gdlr-speaker-thumbnail-inner" v-if="expert && expert.surname && expert.forename && !expert.slug">
                                                            <div v-if="expert && expert.avatarSquareSmall && expert.avatarSquareSmall.xxx" class="sands-image-colored-overlay-hover">
                                                                <img :src="expert.avatarSquareSmall.xxx" :alt="expert.forename + ' ' + expert.surname" width="500" height="350"></div>
                                                            <div class="span-speaker-container">
                                                                <p class="span-speaker-left"><span>{{expert.forename}}</span> <span> {{expert.surname}}</span></p>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="!sessionDetail.experts && sessionDetail.wpExperts && sessionDetail.wpExperts.length" class='global-border-radius speaker-boxes ws-lp'>
                                                <h3>Speaker</h3>
                                                <div v-for="expert in sessionDetail.wpExperts" :key="expert.id">
                                                    <div v-if="showWPData" class="gdlr-speaker-thumbnail">
                                                        <div class="gdlr-speaker-thumbnail-inner" v-if="expert && expert.name && expert.slug"><a :href="'/speaker/'+expert.slug">
                                                                <div v-if="expert && expert.image" class="sands-image-colored-overlay-hover" v-html="expert.image"></div>
                                                                <div class="span-speaker-container">
                                                                    <p class="span-speaker-left"><span> {{expert.name}}</span></p>
                                                                    <p class="span-speaker-right">{{ $t('more-info') }}</p>
                                                                </div>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="clear"></div>
                                            <div v-if="widgetHtml" class="call-for-action-box">
                                                <div class="vhtml" v-html="widgetHtml">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="flexbox-2">
                                            <div v-if="displaySessionTopData && sessionDetail.wpRoomInfo">
                                                <div class="session-info-block" v-if="sessionDetail.wpRoomInfo">
                                                    <span v-html="sessionDetail.wpRoomInfo">

                                                    </span>
                                                </div>
                                            </div>
                                            <div class="top-info-container global-bg-color__session global-border-radius mb-3" v-if="(showTimeAndDateBasedOfInstance || sessionDetail.workshopShortLabel) && ((sessionDetail.roomName) || (sessionDetail.localizedStartDate && locationMatchingToCookie && locationMatchingToCookie.location_session_time_is_active) || (sessionDetail.workshopShortLabel))">
                                                <h3 class="speaker-detail-info-text px-4">Infos</h3>
                                                <div class="top-info-flex">
                                                    <div class="top-info" v-if="sessionDetail && sessionDetail.localizedStartDate && sessionDetail.localizedEndDate && locationMatchingToCookie && locationMatchingToCookie.location_session_time_is_active">
                                                        <span class="ws-label" style="font-weight: 600;">{{sessionDetail.sessionStartDate}}<br><span style="font-weight: 400;">{{sessionDetail.sessionStartTime}} - {{sessionDetail.sessionEndTime}}</span></span>
                                                    </div>
                                                    <div v-if="sessionDetail && sessionDetail.roomName && showRoomBasedOfInstance">
                                                        <div class="top-info">
                                                            <span class="ws-label">{{ $t('Room') }}: <br>
                                                                {{sessionDetail.roomName}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div v-if="sessionDetail && sessionDetail.workshopShortLabel">
                                                        <div class="top-info">
                                                            <strong>{{ $t('Buchungshinweis') }}: <br></strong>
                                                            {{sessionDetail.workshopShortLabel}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="accordion" aria-multiselectable="true">
                                                <div class="topcard sessions-accordion-item sessions-accordion-item-not-collapsed">
                                                    <div class="card session-desc global-bg-color__session global-border-radius">
                                                        <div class="card-header"  id="headingTwo" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                            <h3 class="h5 mb-0 uparrow px-4">
                                                                {{ $t('Description') }}
                                                            </h3>
                                                        </div>
                                                        <div id="collapseTwo" class="collapse in">
                                                            <div class="card-block session-desc-content">
                                                                <template v-if="sessionDetail && sessionDetail.details">
                                                                    <div v-html="sessionDetail.details">
                                                                    </div>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="sessionDetail && sessionDetail.longAbstract" class="topcard sessions-accordion-item sessions-accordion-item-not-collapsed">
                                                    <div class="card inhalt-ablauf global-border-radius">
                                                        <div class="card-header"  id="headingTwo" data-toggle="collapse" data-parent="#accordion" href="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                                            <h4 class="h5 mb-0 uparrow">
                                                                {{ $t('Content-Process') }}
                                                            </h4>
                                                        </div>
                                                        <div id="collapseFour" class="collapse in">
                                                            <div class="card-block session-desc-content border-radius-bottom-20 global-bg-color__session">
                                                                <template v-if="sessionDetail && sessionDetail.longAbstract">
                                                                    <div v-html="sessionDetail.longAbstract">
                                                                    </div>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="sessionDetail && sessionDetail.workshopRequirements" class="topcard sessions-accordion-item sessions-accordion-item-not-collapsed">
                                                    <div class="card zielgruppe global-bg-color__session global-border-radius">
                                                        <div class="card-header"  id="headingFive" data-toggle="collapse" data-parent="#accordion" href="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                                            <h4 class="h5 mb-0 uparrow">
                                                                {{ $t('Audience') }}
                                                            </h4>
                                                        </div>
                                                        <div id="collapseFive" class="collapse in">
                                                            <div class="card-block session-desc-content border-radius-bottom-20 global-bg-color__session">
                                                                <template v-if="sessionDetail && sessionDetail.workshopRequirements">
                                                                    <div v-html="sessionDetail.workshopRequirements">
                                                                    </div>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="sessionDetail.tracks && sessionDetail.tracks.length || sessionDetail.wpTracks" id="lastaccordion" class="topcard sessions-accordion-item sessions-accordion-item-not-collapsed lastaccordion" style="border-bottom: 0px solid rgb(230, 230, 230);">
                                                    <div class="card more-sessions global-border-radius global-bg-color__session">
                                                        <div class="card-header"  id="headingThree" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                            <h4 class="h5 mb-0 uparrow px-4">
                                                                {{ $t('moreTracksLable') }}
                                                            </h4>
                                                        </div>
                                                        <div id="collapseThree" class="collapse in" >
                                                            <div class="row card-block more-sessions-content">
                                                                <!--  Weitere session zu thema start -->
                                                                <div class="row col-xs-12 col-sm-12 col-md-12">
                                                                    <div class="clear"></div>
                                                                    <div v-if="sessionDetail.tracks" class="gdlr-item old-gdlr-accordion-item old-gdlr-multiple-tab style-1 old-conentinsideaccordion">
                                                                        <div v-for="relatedTrack in sessionDetail.tracks" :key="relatedTrack._id" class="old-accordion-tab old-active old-pre-active">
                                                                            <p class="old-accordion-title old-ijsstyle old-classicstyle"><span>{{relatedTrack.name}}</span></p>
                                                                            <div v-if="relatedTrack.trackSessions && relatedTrack.trackSessions.vueSessions && relatedTrack.trackSessions.vueSessions.Sessions" class="old-accordion-content">
                                                                                <ul>
                                                                                    <template v-for="arelatedTrack in relatedTrack.trackSessions.vueSessions.Sessions" :key="arelatedTrack._id">
                                                                                        <li class="trackName" v-if="arelatedTrack && arelatedTrack.name && arelatedTrack.slugNames && arelatedTrack.slugNames[0] && arelatedTrack.primaryTrack && arelatedTrack.primaryTrack.slug">
                                                                                            <a v-if="arelatedTrack.slugNames && arelatedTrack.slugNames[0] && arelatedTrack.primaryTrack && arelatedTrack.primaryTrack.slug" :href="'/'+arelatedTrack.primaryTrack.slug+'/'+arelatedTrack.slugNames[0]">{{arelatedTrack.name}}</a>
                                                                                        </li>
                                                                                    </template>
                                                                                    <li><a v-if="relatedTrack && relatedTrack.slug" :href="'/'+relatedTrack.slug" :aria-label="relatedTrack.slug">{{ $t('readMoreLable') }}</a></li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                    <div v-if="!sessionDetail.tracks && sessionDetail.wpTracks" class="gdlr-item old-gdlr-accordion-item old-gdlr-multiple-tab style-1 old-conentinsideaccordion">
                                                                        <div v-for="relatedTrack in sessionDetail.wpTracks" :key="relatedTrack._id" class="old-accordion-tab old-active old-pre-active">
                                                                            <p class="old-accordion-title old-ijsstyle old-classicstyle"><span>{{relatedTrack[0].name}}</span></p>
                                                                            <div class="old-accordion-content">
                                                                                <ul>
                                                                                    <template v-for="arelatedTrack in relatedTrack" :key="arelatedTrack._id">
                                                                                        <li v-if="arelatedTrack && arelatedTrack.title && arelatedTrack.slug"><a :href="arelatedTrack.slug">{{arelatedTrack.title}}</a></li>
                                                                                    </template>
                                                                                    <li v-if="relatedTrack[0].slug"><a :href="relatedTrack[0].slug">{{ $t('readMoreLable') }}</a></li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import queryAndMutaionService from '@/services/queryAndMutaionService';
import moment from 'moment'
import {
    ApolloClient,
    InMemoryCache
} from '@apollo/client/core'
import {
    provideApolloClient,
    useQuery
} from "@vue/apollo-composable";
import CONCORD_QUERIES from "../services/concord_queries.js"
import {
    watch
} from 'vue'

export default {
    name: "SessionDetailCan",
    props: {
        settingsPerm: Object
    },
    data() {
        return {
            settingsFromWP: this.settingsPerm,
            sessionSlug: this.settingsPerm.postSlug,
            brandId: this.settingsPerm.brandId,
            container: this.settingsPerm.container,
            result: null,
            testResults: null,
            loading: true,
            error: true,
            showRoomBasedOfInstance: false,
            showTimeAndDateBasedOfInstance: false,
            showWPData: true,
            displaySessionTopData: false,
            dataToDisplay: [],
            locationsRelatedToThisSession: [],
            currentMlcLocation: null,
            sessionToTake: null,
            conferenceIdSameAsCurrentLocationInstanceId: false,
            locationMatchingToCookie: null,
            mlcDataFromWP: null,
            widgetHtml: this.settingsPerm.widgetHtml,
            dataOrigin: '',
            disturberHtml: this.settingsPerm.disturberHtml,
            showProgramDiv: false,
            editionsOfThisSession: [],
            currentEditionOfThisSession: false,
            sessionAdded: false,
            languageCookie: window.jQuery.cookie("pll_language"),
            editionIdentifier: [], //array of editionInstance_id
            cookieBasedEditionIdentifier: null,
            sessionsBySlug: null,
            cookie: this.getCookie(),
            theMaybeSetPLLCookieValue: window.jQuery.cookie("pll_language"),
            dataArray: {},
            identifierFound: true,
            isArchiveSession: false,
            locationAliasesOfThePost: [],
        };
    },
    created() {
        if (this.settingsPerm && this.settingsPerm.postMlcEditionData) {
            this.mlcDataFromWP = Object.values(this.settingsPerm.postMlcEditionData);
            let thiss = this;
            Object.values(this.settingsPerm.postMlcEditionData).forEach(function (aEdition) {
                if (thiss.cookie && (typeof thiss.cookie !== "undefined") && (thiss.cookie != "") && (thiss.cookie != "all") && thiss.cookie == aEdition.identifier) {
                    // try to get MLC data of current cookie
                    thiss.currentMlcLocation = thiss.settingsPerm.allLocations.find(aLocation => {
                        return aLocation.identifier == thiss.cookie;
                    })
                    //aEdition.show_wp_content == 0 means we don"t want to show WP data
                    if (aEdition && aEdition.show_wp_content && aEdition.show_wp_content == 0) {
                        thiss.showWPData = false;
                    }
                }
                if (thiss.settingsPerm && !thiss.settingsPerm.postContent) {
                    thiss.showWPData = false;
                }
                if ((thiss.cookie && thiss.cookie == 'all') || thiss.cookie == undefined || !thiss.cookie) {
                    if ((aEdition && aEdition.show_wp_content && aEdition.show_wp_content == 1) || (thiss.settingsPerm && !thiss.settingsPerm.postContent)) {
                        thiss.showWPData = false;
                    }
                }
                if (aEdition && aEdition.edition_identifier) {
                    thiss.editionIdentifier.push(aEdition.edition_identifier);
                }
                if (thiss.cookie && (typeof thiss.cookie !== "undefined") && (thiss.cookie != "") && (thiss.cookie != "all")) {
                    if (aEdition && aEdition.identifier && aEdition.identifier == thiss.cookie) {
                        thiss.cookieBasedEditionIdentifier = aEdition.edition_identifier;
                    }
                }

            })
        }
        if (this.languageCookie) {
            moment.locale(this.languageCookie);
        }
        if (this.settingsPerm && this.settingsPerm.postSlug) {
            const cache = new InMemoryCache();
            const apolloClient = new ApolloClient({
                cache,
                uri: window.walkuere_app_data.concord_url,
            })
            provideApolloClient(apolloClient)
            let variablesForQier = {
                sessionSlug: this.sessionSlug,
                brandId: this.brandId
            };
            const {
                result
            } = useQuery(CONCORD_QUERIES.SESSION_BY_SLUG_QUERY, variablesForQier);
            watch(result, value => {
                if (value && result && value.vueSessions && value.vueSessions.Sessions && value.vueSessions.Sessions.length) {
                    this.result = value;
                }
                if (value && result && value.vueSessions && value.vueSessions) {
                    if (this.result && this.result.vueSessions && this.result.vueSessions.Sessions && this.result.vueSessions.Sessions.length && !this.sessionAdded && !this.showWPData) {
                        let sessionsForThissession = [];
                        let eachSessionStartTime = [];
                        let thiz = this;
                        let counter = 0;

                        this.result.vueSessions.Sessions.forEach(function (aSession) {
                            if (aSession.localizedStartDate) {
                                eachSessionStartTime.push(moment(aSession.localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('x'));
                            }
                            let isCurrentSerie = false;
                            if (aSession && aSession.conferenceIds && aSession.conferenceIds.length) {
                                aSession.conferenceIds.forEach(conferenceID => {
                                    Object.values(thiz.settingsPerm.postMlcEditionData).forEach(aLocationMlcData => {
                                        let isCurrentSerieInner = thiz.settingsPerm.allLocations.find(aCurrentLiveSeries => {
                                            return aCurrentLiveSeries.editionlabel == aLocationMlcData.edition_label;
                                        })
                                        if (isCurrentSerieInner) {
                                            isCurrentSerie = true;
                                        }
                                        if (aLocationMlcData.edition_identifier && aLocationMlcData.edition_identifier == conferenceID && isCurrentSerie) {
                                            thiz.isArchiveSession = false;
                                            thiz.locationsRelatedToThisSession.push(aLocationMlcData);
                                            if (thiz.currentMlcLocation && aLocationMlcData.identifier == thiz.currentMlcLocation.identifier) {
                                                thiz.conferenceIdSameAsCurrentLocationInstanceId = true;
                                            }
                                            if (thiz.cookie && (typeof thiz.cookie !== "undefined") && (thiz.cookie != "") && (thiz.cookie != "all")) {
                                                if (aLocationMlcData.showTimeAndDateForThisSession && aLocationMlcData.identifier == thiz.cookie) {
                                                    thiz.showTimeAndDateBasedOfInstance = true;
                                                    if (aLocationMlcData.location_show_rooms_is_active) {
                                                        thiz.showRoomBasedOfInstance = aLocationMlcData.location_show_rooms_is_active;
                                                    }
                                                }

                                            }
                                            let duplicate = thiz.editionsOfThisSession.find(aEditionofThisSession => {
                                                return aEditionofThisSession.edition_identifier == conferenceID;
                                            })
                                            if (!duplicate) {
                                                thiz.editionsOfThisSession.push(aLocationMlcData);
                                            }
                                            if ((thiz.cookie && thiz.cookie != 'all') && aLocationMlcData && aLocationMlcData.identifier && aLocationMlcData.identifier == thiz.cookie) {
                                                thiz.currentEditionOfThisSession = aLocationMlcData;
                                            }
                                        } else if (!isCurrentSerie && aLocationMlcData.edition_identifier && aLocationMlcData.edition_identifier == conferenceID) {
                                            thiz.isArchiveSession = true;
                                        }
                                    });
                                })
                            }
                            if (thiz.editionIdentifier && thiz.editionIdentifier.length) {
                                if (aSession && aSession.conferenceIds && aSession.conferenceIds.length) {
                                    aSession.conferenceIds.forEach(conferenceID => {
                                        if (thiz.editionIdentifier.includes(conferenceID)) {
                                            sessionsForThissession.push(aSession);
                                        }
                                    })
                                }
                            } else {
                                sessionsForThissession.push(aSession);
                            }
                            counter++;
                            if (counter == thiz.result.vueSessions.Sessions.length && sessionsForThissession.length == 0) {
                                sessionsForThissession.push(aSession);
                                thiz.identifierFound = false;
                            }

                        });

                        if (sessionsForThissession && sessionsForThissession.length) {

                            if (sessionsForThissession && sessionsForThissession.length >= 2) {
                                if ((this.cookie && this.cookie == 'all') || this.cookie == undefined || !this.cookie) {

                                    eachSessionStartTime = this.max(eachSessionStartTime);
                                    sessionsForThissession = sessionsForThissession.filter(aSession => {
                                        return moment(aSession.localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('x') == eachSessionStartTime;
                                    })
                                } else {
                                    if (this.cookie && this.cookieBasedEditionIdentifier && this.cookieBasedEditionIdentifier.length && !thiz.isArchiveSession) {
                                        sessionsForThissession = sessionsForThissession.filter(aSession => {
                                            return aSession.conferenceIds.includes(this.cookieBasedEditionIdentifier);
                                        })
                                    } else if (thiz.isArchiveSession) {
                                        eachSessionStartTime = this.max(eachSessionStartTime);
                                        sessionsForThissession = sessionsForThissession.filter(aSession => {
                                            return moment(aSession.localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('x') == eachSessionStartTime;
                                        })
                                    }
                                }
                            }
                        }
                        if (sessionsForThissession && sessionsForThissession.length) {
                            this.sessionAdded = true;
                            if (sessionsForThissession[0] && sessionsForThissession[0].slugNames[0]) {
                                this.dataArray['SessionSlug'] = sessionsForThissession[0].slugNames[0]; // why we get slug names as array 
                                this.getAndSetArchiveSessionData(sessionsForThissession[0]);
                            } else if (this.settingsPerm.postSlug) {
                                this.dataArray['SessionSlug'] = this.settingsPerm.postSlug;
                            }

                            if (sessionsForThissession[0] && sessionsForThissession[0].details) {
                                this.dataArray['details'] = sessionsForThissession[0].details;
                            } else if (this.settingsPerm.postContent) {
                                this.dataArray['details'] = this.settingsPerm.postContent;
                            }

                            if (sessionsForThissession[0] && sessionsForThissession[0].name) {
                                this.dataArray['title'] = sessionsForThissession[0].name;
                            } else if (this.settingsPerm.postContent) {
                                this.dataArray['title'] = this.settingsPerm.postTitle;
                            }

                            if (sessionsForThissession[0] && sessionsForThissession[0].experts && sessionsForThissession[0].experts.length) {
                                this.dataArray['experts'] = sessionsForThissession[0].experts;
                            } else if (this.settingsPerm.postExperts) {
                                this.dataArray['wpExperts'] = this.settingsPerm.postExperts;
                            }

                            if (sessionsForThissession[0] && sessionsForThissession[0].tracks && sessionsForThissession[0].tracks.length) {
                                let duplicateTracksArry = [];
                                sessionsForThissession[0].tracks.forEach(aTrack => {
                                    let duplicate = aTrack;
                                    duplicate = Object.assign({
                                        trackSessions: this.getSesisonsByTrack(aTrack, sessionsForThissession[0].conferenceIds[0])
                                    }, aTrack);
                                    duplicateTracksArry.push(duplicate);
                                });
                                this.dataArray['tracks'] = duplicateTracksArry;
                            } else if (Object.values(this.settingsPerm.postRelatedSessions)) {
                                this.dataArray['wpTracks'] = Object.values(this.settingsPerm.postRelatedSessions);
                            }

                            if (sessionsForThissession[0] && sessionsForThissession[0].roomName) {
                                this.dataArray['roomName'] = sessionsForThissession[0].roomName;
                            } else if (this.settingsPerm.htmlForInfo && !sessionsForThissession[0].localizedStartDate && !sessionsForThissession[0].workshopShortLabel) {
                                this.dataArray['wpRoomInfo'] = this.settingsPerm.htmlForInfo;
                            }

                            if (sessionsForThissession[0] && sessionsForThissession[0].localizedStartDate) {
                                this.dataArray['localizedStartDate'] = moment(sessionsForThissession[0].localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('DD-MM-YYYY');
                            }

                            if (sessionsForThissession[0] && sessionsForThissession[0].workshopShortLabel) {
                                this.dataArray['workshopShortLabel'] = sessionsForThissession[0].workshopShortLabel;
                            }
                            if (sessionsForThissession[0] && sessionsForThissession[0].longAbstract) {
                                this.dataArray['longAbstract'] = sessionsForThissession[0].longAbstract;
                            }

                            if (sessionsForThissession[0] && sessionsForThissession[0].workshopRequirements) {
                                this.dataArray['workshopRequirements'] = sessionsForThissession[0].workshopRequirements;
                            }
                            if (sessionsForThissession[0] && sessionsForThissession[0].localizedEndDate) {
                                this.dataArray['localizedEndDate'] = moment(sessionsForThissession[0].localizedEndDate, 'DD/MM/YYYY HH:mm:ss').format('DD-MM-YYYY');
                            }

                            if (sessionsForThissession[0] && sessionsForThissession[0].localizedStartDate) {
                                this.dataArray['startTime'] = moment(sessionsForThissession[0].localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('HH:mm');
                            }
                            if (sessionsForThissession[0] && sessionsForThissession[0].localizedStartDate && sessionsForThissession[0].localizedEndDate) {
                                let timeToAdd;
                                if ((this.cookie && this.cookie == 'all') || this.cookie == undefined || !this.cookie) {
                                    //if cookie is all or undefined or null how much hours to add
                                    if (this.editionsOfThisSession[0] && this.editionsOfThisSession[0].manipulateSessionTime) {
                                        timeToAdd = this.editionsOfThisSession[0].manipulateSessionTime;
                                    }
                                } else if (this.cookie && (typeof this.cookie !== "undefined") && (this.cookie != "") && (this.cookie != "all")){
                                    let currenteditionData = this.editionsOfThisSession.find(aEdition => {
                                        return aEdition.identifier == this.cookie;
                                    })
                                    if (currenteditionData && currenteditionData.manipulateSessionTime) {
                                        timeToAdd = currenteditionData.manipulateSessionTime;
                                    }else{
                                        timeToAdd = 0;
                                    }
                                }

                                if (this.languageCookie && this.languageCookie == 'de') {
                                    if (Math.sign(timeToAdd) === 1) {
                                        this.dataArray['sessionStartDate'] = moment(sessionsForThissession[0].localizedStartDate, 'DD/MM/YYYY HH:mm:ss').add(Math.abs(timeToAdd), 'hours').format('dddd, DD. MMMM YYYY');
                                    } else if (Math.sign(timeToAdd) === -1) {
                                        this.dataArray['sessionStartDate'] = moment(sessionsForThissession[0].localizedStartDate, 'DD/MM/YYYY HH:mm:ss').subtract(Math.abs(timeToAdd), 'hours').format('dddd, DD. MMMM YYYY');
                                    }
                                } else {
                                    if (Math.sign(timeToAdd) === 1) {

                                        this.dataArray['sessionStartDate'] = moment(sessionsForThissession[0].localizedStartDate, 'DD/MM/YYYY HH:mm:ss').add(Math.abs(timeToAdd), 'hours').format('dddd, MMMM DD YYYY');
                                    } else if (Math.sign(timeToAdd) === -1) {
                                        this.dataArray['sessionStartDate'] = moment(sessionsForThissession[0].localizedStartDate, 'DD/MM/YYYY HH:mm:ss').subtract(Math.abs(timeToAdd), 'hours').format('dddd, MMMM DD YYYY');
                                    }
                                }
                                if (this.editionsOfThisSession && this.editionsOfThisSession.length) {

                                    if (this.currentEditionOfThisSession && this.currentEditionOfThisSession.manipulateSessionTime) {
                                        timeToAdd = this.currentEditionOfThisSession.manipulateSessionTime;
                                    }
                                    if (Math.sign(timeToAdd) === 1) {
                                        this.dataArray['sessionStartTime'] = moment(sessionsForThissession[0].localizedStartDate, 'DD/MM/YYYY HH:mm:ss').add(Math.abs(timeToAdd), 'hours').format('HH:mm');
                                        this.dataArray['sessionEndTime'] = moment(sessionsForThissession[0].localizedEndDate, 'DD/MM/YYYY HH:mm:ss').add(Math.abs(timeToAdd), 'hours').format('HH:mm');
                                    } else if (Math.sign(timeToAdd) === -1) {
                                        this.dataArray['sessionStartTime'] = moment(sessionsForThissession[0].localizedStartDate, 'DD/MM/YYYY HH:mm:ss').subtract(Math.abs(timeToAdd), 'hours').format('HH:mm');
                                        this.dataArray['sessionEndTime'] = moment(sessionsForThissession[0].localizedEndDate, 'DD/MM/YYYY HH:mm:ss').subtract(Math.abs(timeToAdd), 'hours').format('HH:mm');
                                    }
                                } else {
                                    this.dataArray['sessionStartTime'] = moment(sessionsForThissession[0].localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('HH:mm');
                                    this.dataArray['sessionEndTime'] = moment(sessionsForThissession[0].localizedEndDate, 'DD/MM/YYYY HH:mm:ss').format('HH:mm');
                                }
                            }

                            if (sessionsForThissession[0] && sessionsForThissession[0].localizedEndDate) {
                                this.dataArray['endTime'] = moment(sessionsForThissession[0].localizedEndDate, 'DD/MM/YYYY HH:mm:ss').format('HH:mm');
                            }
                            if (sessionsForThissession[0] && sessionsForThissession[0].sessionType && sessionsForThissession[0].sessionType.name && sessionsForThissession[0].sessionType.slug) {
                                let sessionTypeIs = {
                                    "name": sessionsForThissession[0].sessionType.name,
                                    "slug": sessionsForThissession[0].sessionType.slug
                                }
                                this.dataArray['sessionTypeIs'] = sessionTypeIs;
                            }
                            this.dataArray['SessionEditionLabels'] = this.settingsPerm.postEditionLabels;
                            this.dataArray['SessionEditionData'] = this.settingsPerm.EditionData;
                            this.dataArray['SessionMlcEditionData'] = this.settingsPerm.MlcEditionData;
                            this.dataArray['dataOrigin'] = 'concord/wp';
                            this.dataToDisplay.push(this.dataArray);
                            this.loading = false;
                        }
                    } else if (!this.sessionAdded) {
                        this.sessionAdded = true;
                        this.showWPData = true;
                        if (this.showWPData) {
                            this.dataOrigin = 'WP';
                            this.dataArray['SessionSlug'] = this.settingsPerm.postSlug;
                            this.dataArray['details'] = this.settingsPerm.postContent;
                            this.dataArray['title'] = this.settingsPerm.postTitle;
                            this.dataArray['SessionEditionLabels'] = this.settingsPerm.postEditionLabels;
                            this.dataArray['SessionEditionData'] = this.settingsPerm.EditionData;
                            this.dataArray['SessionMlcEditionData'] = this.settingsPerm.MlcEditionData;
                            this.dataArray['wpExperts'] = this.settingsPerm.postExperts;
                            this.dataArray['wpTracks'] = Object.values(this.settingsPerm.postRelatedSessions);
                            if (this.settingsPerm && this.settingsPerm.wpworkshoprequirements) {
                                this.dataArray['workshopRequirements'] = this.settingsPerm.wpworkshoprequirements;
                            }
                            if (this.settingsPerm && this.settingsPerm.wplongAbstrct) {
                                this.dataArray['longAbstract'] = this.settingsPerm.wplongAbstrct;
                            }
                            this.dataArray['wpRoomInfo'] = this.settingsPerm.htmlForInfo;
                            this.dataArray['_id'] = this.settingsPerm.postid;
                            this.dataArray['sessionTypeIs'] = this.settingsPerm.sessionTyp;
                            this.dataToDisplay.push(this.dataArray);
                            this.loading = false;
                        } else {
                            this.dataOrigin = 'concord';
                        }
                    }
                    if (this.dataToDisplay && this.dataToDisplay.length) {
                        let schemaOrg = document.getElementsByClassName('yoast-schema-graph');
                        if (schemaOrg && schemaOrg.length && schemaOrg[0].innerHTML) {
                            let newDataSrting = schemaOrg[0].innerHTML.replaceAll('@', 'AAA20')
                            let schemaInnerHtml = JSON.parse(newDataSrting);

                            if (schemaInnerHtml && schemaInnerHtml.AAA20graph && schemaInnerHtml.AAA20graph.length) {
                                schemaInnerHtml.AAA20graph[0].description = this.dataToDisplay[0].details;
                            }
                            schemaInnerHtml = JSON.stringify(schemaInnerHtml);
                            let newDataAsString = schemaInnerHtml.replaceAll('AAA20', '@')
                            schemaOrg[0].innerHTML = newDataAsString;
                        }

                        if (this.dataToDisplay[0] && this.dataToDisplay[0].title) {
                            var title = document.createElement('title');
                            title.innerHTML = this.dataToDisplay[0].title;
                            var head = document.getElementsByTagName('head')[0];
                            head.insertBefore(title, head.firstChild)
                        }
                        let meta = {
                            "title": this.dataToDisplay[0].title,
                            "description": this.dataToDisplay[0].details,
                            "robots": "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1",
                            "canonical": window.location.href,
                            "og:locale": "en_GB",
                            "og:type": "article",
                            "og:title": this.dataToDisplay[0].title,
                            "og:description": this.dataToDisplay[0].details,
                            "og:url": window.location.href,
                            "og:site_name": this.settingsPerm.siteInfo,
                        }
                        let metaArry = Object.keys(meta);
                        metaArry.forEach(key => {
                            var metaTag = document.createElement('meta');
                            metaTag.setAttribute('name', key);
                            metaTag.setAttribute('content', meta[key]);
                            document.getElementsByTagName('head')[0].appendChild(metaTag)
                        });
                    }

                } else {
                    this.loading = false;
                }
            })
            let concordData = queryAndMutaionService.getSessionsBySlug(this.sessionSlug, this.brandId);
            if (concordData && concordData.error) {
                this.error = concordData.error;
            }
        }
        if (this.cookie && (typeof this.cookie !== "undefined") && (this.cookie != "") && (this.cookie != "all")) {
            this.locationMatchingToCookie = this.settingsPerm.allLocations.find(aLocation => {
                return aLocation.identifier == this.cookie;
            })

            if (this.locationMatchingToCookie && this.locationMatchingToCookie.location_session_time_is_active) {
                this.displaySessionTopData = this.locationMatchingToCookie.location_session_time_is_active;
            }
        }

    },
    beforeUpdate() {},
    updated() {
        this.cookie = window.jQuery.cookie("event_location");
        if (this.cookie && (typeof this.cookie !== "undefined") && (this.cookie != "") && (this.cookie != "all")) {
            window.jQuery('.mlc-location-dependent-block-invisible.' + this.cookie).addClass('mlc-location-dependent-block-visible');
            window.jQuery('.mlc-location-dependent-block-invisible.' + this.cookie).removeClass('mlc-location-dependent-block-invisible');
        } else {
            // we do NOT have a location so we do somtehing with location dependend things
            window.jQuery('.mlc-location-independent-block-invisible').addClass('mlc-location-independent-block-visible');
            window.jQuery('.mlc-location-independent-block-invisible').removeClass('mlc-location-independent-block-invisible');
        }
        if (this.theMaybeSetPLLCookieValue && (typeof this.theMaybeSetPLLCookieValue !== "undefined") && (this.theMaybeSetPLLCookieValue != "") && (this.theMaybeSetPLLCookieValue == 'de')) {
            window.jQuery('.language-dependent-block-invisible-de').addClass('language-dependent-block-visible');
            window.jQuery('.language-dependent-block-invisible-de').removeClass('language-dependent-block-invisible-de');
        } else {
            window.jQuery('.language-dependent-block-invisible').addClass('language-dependent-block-visible');
            window.jQuery('.language-dependent-block-invisible').removeClass('language-dependent-block-invisible');
        }
        if (this.widgetHtml && this.widgetHtml && window["moveDisturber"]) {
            window["moveDisturber"]();
        }
    },
    methods: {
        getAndSetArchiveSessionData(session) {
            let thiz = this;
            if (session && this.settingsPerm.postMlcEditionData) {
                Object.values(this.settingsPerm.postMlcEditionData).forEach(aLocationMlcData => {
                    let isCurrentSerie = thiz.settingsPerm.allLocations.find(aCurrentLiveSeries => {
                        return aCurrentLiveSeries.editionlabel == aLocationMlcData.edition_label;
                    })
                    if (aLocationMlcData && aLocationMlcData.edition_identifier && session.conferenceIds.includes(aLocationMlcData.edition_identifier) && !isCurrentSerie) {
                        thiz.locationAliasesOfThePost.push(aLocationMlcData);
                    }
                });

            }
        },
        getCookie() {
            return window.jQuery.cookie("event_location");
        },
        max(eachSessionStartTime) {
            return Math.max.apply(null, eachSessionStartTime);
        },
        getSesisonsByTrack(aTrack, conferenceId) {
            let concordSessionOfATrack = queryAndMutaionService.getSessionsByTrack(aTrack._id, conferenceId);
            if (concordSessionOfATrack && concordSessionOfATrack.result) {
                return concordSessionOfATrack.result;
            }
        },
        getThisSessionLocation(edition) {
            var activeCities = [];
            if (edition && edition.edition_identifier && this.result && this.result.vueSessions && this.result.vueSessions.Sessions) {
                this.result.vueSessions.Sessions.forEach(aSession => {
                    if (aSession && aSession.conferenceIds && aSession.conferenceIds.includes(edition.edition_identifier)) {
                        if (activeCities.find(e => e.city === edition.city)) {
                            return
                        } else {
                            let cityInfo = {
                                "cityDe": edition.city_de,
                                "city": edition.city,
                                "location_color": edition.location_color,
                                "identifier": edition.identifier,
                                "programbuttonLink_DE": edition.programbuttonLink_DE,
                                "programbuttonLink": edition.programbuttonLink,
                            }
                            activeCities.push(cityInfo)
                        }

                    }
                });
            }
            // console.log('edition incoming', edition);
            return activeCities;
        }
    },
};
</script>

<style lang="css" scoped>

.border-radius-bottom-20 {
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

table,
th,
td {
    border: 1px solid black;
    border-collapse: collapse;
}

th,
td {
    padding: 5px;
    text-align: left;
    color: black;
}

.session-info-block {
    margin-bottom: 20px;
}

.top-info-container.mb-3 {
    margin-bottom: 12px;
}

.to-the-current-program-page-block {
    padding: 15px 8px 0 20px;
    vertical-align: middle;
    font-weight: 600;
    margin-bottom: 15px;
    padding-bottom: 10px;
    text-align: left;
}

.to-the-current-program-page-block .go-to-program-page.language-dependent-block-visible {
    display: inline-block !important;
}

.gdlr-speaker-thumbnail {
    margin: 0 20px 30px 20px;
}

.global-bg-color__session {
    background-color: #f0f0f0;

}

.ex__new__wrapper {
    background-color: #fff;
}

.single-session .sands-gdlr-page-title {
    color: #000;
    font-family: "Open Sans";
    font-size: 60px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: lowercase;

}

.vue-talk-detail h3,.vue-talk-detail h2 {
    font-size: 35px;
    font-style: normal;
    font-weight: 600;
    line-height: 38px;
    /* 108.571% */
    text-transform: capitalize;
}

.vue-talk-detail .session-type {
    color: #000;
}

.vue-talk-detail .gdlr-page-title-wrapper.gdlr-parallax-wrapper.gdlr-title-normal {
    background-image: none !important;
}

body.single.single-session .content-wrapper {
    background-color: #fff !important;
}

.padding-top-0.topcard.sessions-accordion-item {
    padding-top: 0px !important;
}

.speaker-boxes {
    padding: 0 0 9px 0px;
    margin: 0 0 20px 0;
}

/*.speaker-boxes.ws-lp .gdlr-speaker-thumbnail{
        max-width: 300px;
        margin: auto;
    } */

.speaker-boxes h3 ,.speaker-boxes h2{
    padding: 15px 20px 10px 20px;
    border-bottom: 1px solid #efefef;
    margin-top: 0px;
}

.top-info-container h5 {
    margin: 0;
}

.top-info-flex {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.top-info-flex .top-info {
    border-right: 1px solid #efefef;
    height: 100%;
    padding: 30px;
    margin: 0;
    flex: 1;
    text-align: center;
}

.top-info-flex .top-info:last-child {
    border: none;
}

.session-desc .card-header h5,.session-desc .card-header h4 {
    padding: 0 20px;
}

.session-desc-content {
    padding: 10px 20px 15px 20px;
    border-top: 1px solid #efefef;
}

.inhalt-ablauf {
    background-color: #fff;
    box-shadow: 0 -1px 0 #e5e5e5, 0 0 2px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.24);
}

.inhalt-ablauf .card-header h5, .inhalt-ablauf .card-header h4 {
    padding: 0 20px;
}

.inhalt-ablauf-content {
    padding: 10px 20px 15px 20px;
    border-top: 1px solid #efefef;
}

.zielgruppe {
    background-color: #fff;
    box-shadow: 0 -1px 0 #e5e5e5, 0 0 2px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.24);
}

.zielgruppe .card-header h5, .zielgruppe .card-header h4 {
    padding: 0 20px;
}

.zielgruppe-content {
    padding: 10px 20px 15px 20px;
    border-top: 1px solid #efefef;
}

.zielgruppe .sands-workshop-requirements {
    background-color: transparent;
    border: 0px;
    margin: 0;
    padding: 0px;
}

.more-sessions .card-header h5 {
    padding: 0 20px;
}

.more-sessions-content {
    padding: 10px 20px 15px 20px;
}

.gdlr-accordion-item.style-1 .accordion-tab {
    border: none !important;
}

.single-session .gdlr-accordion-item.style-1 .accordion-title i {
    border-bottom-left-radius: 8px !important;
    border-top-left-radius: 8px !important;
}

.workshopshortlabel {
    /* position: relative;
        top: 2px; */
    text-align: center;
}

.single-session .tagcontaineritem {
    padding: 6px;
    border-radius: 6px;
    display: inline-block;
    margin-top: 5px;
    margin-right: 5px;
    text-decoration: none;
}

.session-type {
    font-size: 30px;
    margin: 12px 20px 0px;
    display: block;
}

.sands-flex-outer-container {
    margin: 0;
    padding: 0;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    -webkit-justify-content: center;
    -webkit-align-items: center;
    -webkit-flex-direction: column;
    flex-direction: column;
}

.sands-flex-container {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    flex-flow: row nowrap;
    -webkit-flex-flow: row nowrap;
    align-items: center;
    -webkit-align-items: center;
    justify-content: space-around;
    -webkit-justify-content: space-around;
}

.sands-inner-flex-container {
    margin: 0;
    padding: 0;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    margin-top: 30px;
}

.topcard.sessions-accordion-item-collapsed,
.topcard.sessions-accordion-item-not-collapsed {
    color: #000;
    position: relative;
}

.topcard.sessions-accordion-item-not-collapsed {
    padding: 25px 0;
}

.topcard.sessions-accordion-item-collapsed h4,
.topcard.sessions-accordion-item-not-collapsed h4,
.top-info-container h4,
.topcard.sessions-accordion-item-collapsed h3,
.topcard.sessions-accordion-item-not-collapsed h3,
.top-info-container h3 {
    color: #000;
    position: relative;
    padding-top: 16px;
    padding-bottom: 16px;
    margin: 0px;
    font-size: 25px;
    font-style: normal;
    font-weight: 600;
    line-height: 38px;
    /* 108.571% */
    text-transform: capitalize;
}

.uparrow:after {
    content: '\f106';
    font-family: FontAwesome;
    font-weight: normal;
    font-style: normal;
    margin: 0px 0px 0px 10px;
    text-decoration: none;
    float: right;
    color: #c1c1c1;
    font-size: 25px;
    position: relative;
}

.downarrow:after {
    content: '\f107';
    font-family: FontAwesome;
    font-weight: normal;
    font-style: normal;
    margin: 0px 0px 0px 10px;
    text-decoration: none;
    float: right;
    color: #000;
    font-size: 25px;
    position: relative;
}

.single-session .zum-aktuellen-program {
    padding: 15px 8px 0 12px;
    box-shadow: 0 -1px 0 #e5e5e5, 0 0 2px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.24);
    display: grid;
    vertical-align: middle;
    background-color: #fff;
    font-weight: 600;
    margin-bottom: 15px;
    text-align: center;
}

.single-session .zum-aktuellen-program .text {
    margin-bottom: 10px;
}

.span-speaker-left {
    color: #000;
    text-decoration: none;
    font-size: 18px;
    margin: 0;

}

.span-speaker-right {
    color: #6B6B6B;

}

.span-speaker-right:after {
    content: '\f105';
    font-family: FontAwesome;
    font-weight: normal;
    font-style: normal;
    margin: 0px 0px 0px 10px;
    text-decoration: none;
    color: #6B6B6B;
    position: relative;
}

.span-speaker-container {
    margin-top: 5px;
    margin-bottom: 10px;
}

.gdlr-speaker-thumbnail:hover {
    background: transparent !important;
}

.single-session .gdlr-session-info-wrapper {
    min-width: 100% !important;
}

.single-session .call-for-action-box {
    margin: 0em !important;
    clear: both;
}

.single-session .nomarginbox {
    margin: 0 !important;
    padding: 0 !important;
    margin-bottom: 5px !important;
}

.single-session .weiteretalkslink a {
    font-size: 12px !important;
    text-align: left !important;
    margin-right: 10px;
}

.single-session .anglearrow {
    color: #c1c1c1;
}

.single-session .gdlr-session-info-wrapper {
    margin-bottom: 0px;
}

.single-session .active .accordion-title {
    overflow: hidden;
    display: inline-block;
    padding-right: 15px;
    border-radius: 8px;
}

.single-session .gdlr-accordion-item.style-1 .accordion-title i {
    height: 100%;
    padding: 12px 21px 11px 12px;
}

.single-session .pre-deactive .accordion-title {
    background-color: #f1f1f1 !important;
    color: #000 !important;
    overflow: hidden;
    display: inline-block;
    padding-right: 15px;
    border-radius: 8px;
}

.single-session .pre-deactive i {
    background-color: #c4c4c4 !important;
    color: #fff !important;
}

.card-block {
    cursor: default;
}

.speaker-infos .sands-image-colored-overlay-hover:hover::after {
    background: transparent;
}

.card.more-sessions #collapseThree {
    border-top: 1px solid #eee;
}

@media only screen and (max-width: 991px) {
    .single-session .gdlr-page-title-wrapper .gdlr-page-title-container {
        top: -20px !important;
        padding: 0px;
    }

    .gdlr-page-title-wrapper .gdlr-page-caption {
        font-size: 16px;
    }

    .single-session .sands-gdlr-page-title {
        font-size: 26px;
        text-transform: inherit;
        max-width: 100% !important;
        margin-top: 15px;
    }

    .session-type {
        font-size: 20px;
    }

    .single-session .tagcontaineritem {
        font-size: 12px;
    }

    .disturberstyle {
        display: block;
        right: 0px !important;
        display: block !important;
        top: -50px !important;
        width: 40% !important;
        position: absolute !important;
    }

    .gdlr-page-title-wrapper .gdlr-page-caption {
        font-style: inherit !important;
    }

    /*--*/

    .gdlr-accordion-item.style-1 .pre-active .accordion-title {
        display: table !important;
        min-width: 150px;
        border-radius: 12px;
    }

    .single-session .tagcontainer {
        margin-left: 20px;
        margin-top: 15px;
    }

    .sands-inner-flex-container {
        margin: 0;
        padding: 0;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        -webkit-justify-content: center;
        -webkit-align-items: center;
        -webkit-flex-direction: column;
        flex-direction: column;
        width: 100%;
        -webkit-justify-content: flex-start;
        justify-content: flex-start;
    }

    .flexbox-1 {
        width: 100%;
        -webkit-box-ordinal-group: 2;
        -moz-box-ordinal-group: 2;
        -ms-flex-order: 2;
        -webkit-order: 2;
        order: 2;
    }

    .flexbox-2 {
        width: 100%;
        -webkit-box-ordinal-group: 1;
        -moz-box-ordinal-group: 1;
        -ms-flex-order: 1;
        -webkit-order: 1;
        order: 1;
    }

    /* For the theme*/

    .single-session .pre-deactive .accordion-title {
        font-size: 13px;
    }

    .single-session .ws-label {
        font-size: 16px;
        display: block;
        text-transform: initial;
    }

    .single-session .topicon {
        min-width: 25px;
        color: #a3a3a3;
        font-size: 16px;
    }

    .single-session .gdlr-page-title-wrapper {
        padding: 90px 0px 46px !important;
    }

    .single-session .gdlr-accordion-item.style-1 .accordion-content {
        margin-left: 0px !important;
    }

    .header-date {
        margin-left: 20px;
        color: #fff;
        font-size: 16px;
    }

    .single-session .ws-label {
        margin-bottom: 10px;
        font-family: Montserrat;
    }

    .card-block * {
        font-size: 14px;
        font-family: Montserrat !important;
    }

    .gdlr-item {
        margin: 0px !important;
    }

    .single-session .gdlr-accordion-item.style-1 .accordion-title i {
        padding: 12px 20px 13px 9px;
    }

    .gdlr-accordion-item.style-1 .accordion-title span {
        margin: 0px;
        padding: 0px;
        line-height: 2.5em;
        letter-spacing: -0.9px;
    }

    .top-info-flex {
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .top-info-flex .top-info {
        border-bottom: 1px solid #efefef;
        width: 100%;
        padding: 30px 30px 5px 30px;
        padding-top: 10px;
        margin: 0;
    }

    .sessions-accordion-item .card h5 {
        padding: 10px 20px;
    }

    h5.downarrow {
        margin-top: 0px;
        margin-bottom: 0px;
    }

    .disturberstyle {
        display: none !important;
    }

    .single-session .zum-aktuellen-program {
        margin-top: 12px;
    }

    .speaker-boxes.ws-lp .gdlr-speaker-thumbnail {
        max-width: 300px;
        margin: auto;
        padding: 12px;
    }

    .more-sessions-content {
        padding: 10px 20px 15px 36px;
    }

}

a.tagcontaineritem.ijsstyle.classicstyle {
    color: #fff !important;
}

@media only screen and (max-width: 1150px) {
    .single-session .sands-gdlr-page-title {
        font-size: 40px;
    }
}

@media only screen and (min-width: 992px) {
    .session-type {
        color: #ffffff;
    }

    .single-session .sands-gdlr-page-title {
        text-transform: inherit;
        max-width: 80%;
        padding-top: 10px;
    }

    .disturberstyle {
        bottom: 0px;
        display: block;
        right: 0px !important;
        display: block !important;
        top: -120px !important;
        width: 20% !important;
        position: absolute !important;
    }

    .accordion-title.ijsstyle,
    .accordion-title.classicstyle {
        display: table !important;
        min-width: 300px !important;
        border-radius: 8px !important;
    }

    .gdlr-speaker-thumbnail img {
        width: 100%;
    }

    .previous-next-container h3 {
        font-size: 17px !important;
        font-weight: bold;
    }

    .single-session .sands-gdlr-page-title {
        font-weight: bold;
    }

    .gdlr-page-title-wrapper .gdlr-page-caption {
        font-size: 16px !important;
        font-style: initial !important;
    }

    .flexbox-1 {
        width: 30%;
        min-width: 30%;
    }

    .flexbox-2 {
        margin-left: 20px;
        width: 77%;
    }

    .single-session .tagcontainer {
        margin-left: 20px;
        margin-top: 40px;
        max-width: 50%;
    }

    /* For the theme*/

    .single-session .gdlr-page-title-wrapper {
        padding: 38px 0px 40px;
    }

    .single-session .gdlr-accordion-item.style-1 .accordion-content {
        margin-left: 0px !important;
    }

    .header-date {
        margin-left: 20px;
        color: #fff;
        font-size: 20px;
    }

    .single-session .topicon {
        position: relative;
        top: 4px;
    }

    .single-session .ws-label {
        font-size: 18px;
        display: block;
        text-transform: initial;
        text-align: center;
    }

    .single-session .gdlr-parallax-wrapper {
        background-size: cover;
    }

    .topcard {
        /* padding-bottom: 25px;
        padding-top: 25px; */
        display: grid;
    }

    .topcard:hover {
        cursor: pointer;
    }

}

.speaker-detail-info-text{
    color: #000 !important;
    position: relative !important;
    padding-top: 16px !important;
    padding-bottom: 16px !important;
    margin: 0 !important;
    font-size: 25px !important;
    font-style: normal !important;
    font-weight: 600 !important;
    line-height: 38px !important;
    text-transform: capitalize !important;
}

</style>
